import {Component, HostListener} from '@angular/core';
import {LoginService} from '@services/login.service';
import {CoreConfigService} from '@services/core-config.service';
import {ResponsiveService} from '@core/src/public-api';
import {NotificationService} from '@services/notification.service';
import {RouteInterceptor} from '@shared/interceptors/route.interceptor';
import {ServiceWorkerService} from '@services/service-worker.service';
import {ApiService} from '@services/api.service';
import {ExternalReferenceService} from '@core/src/public-api';

@Component({
  selector: 'si-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(
    private loginService: LoginService,
    private coreConfigService: CoreConfigService,
    private responsiveService: ResponsiveService,
    private notificationService: NotificationService,
    private routeInterceptor: RouteInterceptor,
    private serviceWorkerService: ServiceWorkerService,
    private apiService: ApiService,
    private externalReferenceService: ExternalReferenceService
  ) {
    this.loginService.initRefreshInterval();
    this.coreConfigService.initConfig();
    this.setResponsiveClass();
    this.externalReferenceService.initBodyClass();
    this.notificationService.initNotificationSystem();
    this.routeInterceptor.init();
    this.serviceWorkerService.checkForUpdates();
    this.printVersion();
  }

  setResponsiveClass(): void {
    if (this.responsiveService.isMobile()) {
      document.body.classList.add('mobile');
    } else if (this.responsiveService.isTablet()) {
      document.body.classList.add('tablet');
    } else {
      document.body.classList.add('desktop');
    }
  }

  async printVersion(): Promise<void> {
    const appInfo = await this.apiService.getAppConfigInfo();
    console.log(`Entorno: ${appInfo.entorno}`);
    console.log(`Versión back: ${appInfo.version}`);
    console.log(`Versión front: ${this.apiService.getFrontVersion()}`);
  }

  @HostListener('window:resize')
  onResize(): void {
    this.responsiveService.setCurrentWindowWidth(window.visualViewport.width);
  }
}
